import {
  createSpecializationsByUserModel,
  createUserNewsletterModel,
  createUserStatusModel,
} from "@/forms/form-types/user-model";
import { normalizeFields } from "@/forms/helpers";

export function createFormFields(
  specializations: SelectRawOptions,
  statuses: SelectRawOptions,
  dataForType: any,
  defaultNewsletter: UserNewsletterVM,
  isNewsletterRequired: boolean,
) {
  const model = {
    ...createSpecializationsByUserModel(specializations, dataForType),
    ...createUserStatusModel(statuses, dataForType),
    ...(!defaultNewsletter.isSignedUp
      ? createUserNewsletterModel(isNewsletterRequired)
      : {}),
  };

  return normalizeFields(model);
}
